import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _callSuper from "@babel/runtime/helpers/esm/callSuper";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React from 'react';
import t from 'format-message';
import PropTypes from 'prop-types';
import { Spinner } from '@instructure/ui-spinner';
import { Flex } from '@instructure/ui-flex';
import AlignmentItem from "../../AlignmentItem/index.js";
import Pagination from "../../Pagination/index.js";
export var RESULTS_PER_PAGE = 10;
var OutcomeList = /*#__PURE__*/function (_React$Component) {
  function OutcomeList() {
    _classCallCheck(this, OutcomeList);
    return _callSuper(this, OutcomeList, arguments);
  }
  _inherits(OutcomeList, _React$Component);
  return _createClass(OutcomeList, [{
    key: "renderList",
    value: function renderList() {
      var _this$props = this.props,
        outcomes = _this$props.outcomes,
        isOutcomeSelected = _this$props.isOutcomeSelected,
        selectOutcomeIds = _this$props.selectOutcomeIds,
        deselectOutcomeIds = _this$props.deselectOutcomeIds,
        features = _this$props.features;
      return outcomes.map(function (outcome) {
        return /*#__PURE__*/React.createElement("div", {
          key: outcome.id
        }, /*#__PURE__*/React.createElement(AlignmentItem, {
          outcome: outcome,
          isOutcomeSelected: isOutcomeSelected,
          selectOutcomeIds: selectOutcomeIds,
          deselectOutcomeIds: deselectOutcomeIds,
          isTray: true,
          features: features
        }));
      });
    }
  }, {
    key: "renderLoading",
    value: function renderLoading() {
      return /*#__PURE__*/React.createElement(Flex, {
        justifyItems: "center"
      }, /*#__PURE__*/React.createElement(Flex.Item, {
        padding: "small"
      }, /*#__PURE__*/React.createElement(Spinner, {
        renderTitle: t('Loading')
      })));
    }
  }, {
    key: "renderPagination",
    value: function renderPagination() {
      var _this$props2 = this.props,
        listPage = _this$props2.listPage,
        listTotal = _this$props2.listTotal,
        getOutcomesList = _this$props2.getOutcomesList;
      return /*#__PURE__*/React.createElement(Pagination, {
        page: listPage,
        updatePage: function updatePage(page) {
          return getOutcomesList({
            page: page
          });
        },
        numPages: Math.ceil(listTotal / RESULTS_PER_PAGE)
      });
    }
  }, {
    key: "render",
    value: function render() {
      var isLoading = this.props.isLoading;
      return /*#__PURE__*/React.createElement(Flex, {
        height: "100%",
        width: "100%",
        padding: "none none none none",
        alignItems: "stretch",
        direction: "column"
      }, /*#__PURE__*/React.createElement(Flex.Item, {
        shouldGrow: true
      }, isLoading ? this.renderLoading() : this.renderList()), /*#__PURE__*/React.createElement(Flex.Item, null, !isLoading && this.renderPagination()));
    }
  }]);
  OutcomeList.displayName = "OutcomeList";
}(React.Component);
OutcomeList.propTypes = {
  outcomes: PropTypes.array.isRequired,
  isOutcomeSelected: PropTypes.func.isRequired,
  selectOutcomeIds: PropTypes.func.isRequired,
  deselectOutcomeIds: PropTypes.func.isRequired,
  getOutcomesList: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  listPage: PropTypes.number.isRequired,
  listTotal: PropTypes.number,
  features: PropTypes.array
};
OutcomeList.defaultProps = {
  listTotal: null,
  features: []
};
export { OutcomeList as default };